import React from "react";
import MainNavigation from "../navigation/MainNavigation";

const MainApp: React.FC = () => {
	return <MainNavigation />;
};

export default MainApp;
